import { createAction } from '@reduxjs/toolkit';

/**
 * "Signal" actions: intents the UI dispatches for the saga to act on. Kept out of
 * the slice's reducers: they trigger side effects (load / team fetch / enrich), not
 * state transitions (the saga owns the resulting `load*` / `enrich*` ones).
 */

/** Load the company for the given id (dispatched by the page on mount). */
export const loadRequested = createAction<string>('institutionalDetail/loadRequested');

/** Lazily load the team (dispatched when the Team tab is first opened). */
export const teamRequested = createAction<string>('institutionalDetail/teamRequested');

/** Start enrichment; `force` bypasses the freshness guard. */
export const enrichRequested = createAction<{ id: string; force: boolean }>(
  'institutionalDetail/enrichRequested',
);
